import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import withRecordPopover from '/component/screen/report/withRecordPopover';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_EARNED_CLIENT_SUPPORT_BONUS_PLUS} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';

import {EarnedClientSupportBonusPlusContent} from './EarnedClientSupportBonusPlusContent';
import reportPayload from './reportPayload';

export const EarnedClientSupportBonusPlusReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'Earned Client Support Bonus+')}
      description={tt(
        'description',
        'These Coaches earned their Client Support Bonus+. Time to celebrate & help them to their next milestone!',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={EarnedClientSupportBonusPlusContent}
    />
  );
};

export default withHOC(
  withTranslation('report.earnedClientSupportBonusPlusReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
    popoverContentProps: {},
  }),
)(EarnedClientSupportBonusPlusReport);
